// API 接口示例文件
// 可以根据实际后端接口进行修改

import request from "./request";

export const chatApi = {
  // 创建新案例对话，返回首条欢迎消息 + 主体类型选择题。
  getWelcome: (params: any) => request.post("/chat/v2/conversation/", params),

  // 获取当前用户的对话列表（分页）
  getConversationList: (params: any) =>
    request.get("/chat/v2/conversation/", params),

  // 在指定对话中发送一条用户消息，返回下一条 assistant 消息。
  sendMessage: (conversation_id: string, params: any) =>
    request.post(`/chat/v2/conversation/${conversation_id}/message/`, params),

  // 获取指定对话的详情 + 全量消息（不分页）。
  getConversationDetail: (conversation_id: string) =>
    request.get(`/chat/v2/conversation/${conversation_id}/message/`, {}),

  // 获取用户提交的记录
  getUserSubmission: (params: any) =>
    request.get("/question/v2/submission/", params),

  // 提交案例
  submitCase: (conversation_id: string, params: any) =>
    request.post(`/question/v2/submission/${conversation_id}/`, params),

  // 获取提交详情（用于证书页面）
  getSubmissionDetail: (submission_id: string) =>
    request.get(`/question/v2/submission/${submission_id}/`),
};

export const reportApi = {
  // 查看当前报告解锁状态与价格
  getReportStatus: (submission_id: string) =>
    request.get(`/report/v2/report/${submission_id}/status/`),

  // 花费余额解锁报告章节
  unlockReport: (submission_id: string, data: any) =>
    request.post(`/report/v2/report/${submission_id}/status/`, data),

  // 获取报告结果
  getReportResult: (conversation_id: string) =>
    request.get(`/question/v2/submission/${conversation_id}/`),
};

export const userInfo = {
  //  查看用户当前授权余额
  getBalance: () => request.get("/license/v2/balance/"),
};
